import { render, staticRenderFns } from "./codeDialog.vue?vue&type=template&id=f2387606&scoped=true"
import script from "./codeDialog.vue?vue&type=script&lang=js"
export * from "./codeDialog.vue?vue&type=script&lang=js"
import style0 from "./codeDialog.vue?vue&type=style&index=0&id=f2387606&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2387606",
  null
  
)

export default component.exports